import React from 'react'
import TextBlock from '../TextBlock/TextBlock'
import './Specialties.css'

const items = [
  {
    text: 'Mobile Applications',
    image: require('./img/mobile.png'),
  },
  {
    text: 'Web Applications',
    image: require('./img/web.png'),
  },
  {
    text: 'CMS Customization',
    image: require('./img/cms.png'),
  },
  {
    text: 'Backend systems & More',
    image: require('./img/backend.png'),
  },
]

const SpecialtiesCard = props => {
  return (
    <div className="fmbm-specialties">
      <div className="fmbm-specialties__textblock">
        <TextBlock
          headerText={'Our Specialties'}
          bodyText={
            'Need a team who can handle a full stack application, from the backend to the mobile app? We can do that. Already have a team in place, but have a few missing gaps to fill? We can do that, too.'
          }
          button={{
            text: 'Learn More',
            href: 'https://google.com',
            color: '#113a9c',
          }}
        />
      </div>
      <div className="fmbm-specialties__items">
        {items &&
          items.map((item, key) => {
            let className = 'fmbm-specialties__item '
            if (key % 2 === 0) {
              className += 'wow animated slideInLeft'
            } else {
              className += 'wow animated slideInRight'
            }
            return (
              <div className={className} key={key}>
                <span className="fmbm-specialties__icon">
                  <img src={item.image} alt={item.text} />
                </span>
                {item.text}
              </div>
            )
          })}
      </div>
    </div>
  )
}

export default SpecialtiesCard



// WEBPACK FOOTER //
// ./src/Components/Specialties/Specialties.js